import React from 'react';
import { Aura } from './Aura';
import { Reveal } from './Reveal';
export function Manifesto() {
  return <section id="manifesto" className="relative flex w-full items-center justify-center overflow-hidden bg-black px-5 py-40 text-center" data-id="element-147">
      <Aura className="left-1/2 top-1/2 h-[55vh] w-[110vw] max-w-[1300px] -translate-x-1/2 -translate-y-1/2" data-id="element-148" />

      <div className="relative z-10 mx-auto max-w-5xl" data-id="element-149">
        <Reveal data-id="element-150">
          <span className="text-xs font-medium uppercase tracking-[0.35em] text-white/45" data-id="element-151">
            The Vision
          </span>
        </Reveal>
        <Reveal delay={0.1} data-id="element-152">
          <p className="font-display mt-8 text-4xl uppercase leading-[0.9] tracking-tight text-white text-glow sm:text-7xl md:text-8xl" data-id="element-153">
            We turn cultural influence
            <br className="hidden sm:block" data-id="element-154" /> into shelf space.
          </p>
        </Reveal>
        <Reveal delay={0.2} data-id="element-155">
          <p className="mx-auto mt-8 max-w-xl text-sm font-light leading-relaxed text-white/55 sm:text-base" data-id="element-156">
            Aenigma connects brands, influencers, and creators to the biggest
            retail stages in the country. We license the names, build the drops,
            and place fashion brands of every kind onto the shelves where
            culture actually moves.
          </p>
        </Reveal>
      </div>
    </section>;
}